/* global Litepicker, localData */

// filter offers list
const getFilterOffersData = () => {
  const startDate = window.datepickerStart;
  const endDate = window.datepickerEnd;
  let startDatePicker = '';
  let endDatePicker = '';
  if (startDate && endDate) {
    const startDay = String(startDate.getDate());
    const startMonth = String(startDate.getMonth() + 1);
    const startYear = startDate.getFullYear();
    startDatePicker = `&start=${startYear}${startMonth.padStart(2, '0')}${startDay.padStart(2, '0')}`;

    const endDay = String(endDate.getDate());
    const endMonth = String(endDate.getMonth() + 1);
    const endYear = endDate.getFullYear();
    endDatePicker = `&end=${endYear}${endMonth.padStart(2, '0')}${endDay.padStart(2, '0')}`;
  }
  const request = new XMLHttpRequest();
  const loadingScreen = document.querySelector('.loading');
  loadingScreen.classList.add('is-active');
  request.open('POST', localData.siteURL, true);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
  let dataSelect = '';
  const select = document.querySelector('.filter-nav.select .filter-nav__item.is-active .filter-nav__link');
  if (select) {
    dataSelect = select.getAttribute('data-select');
  }
  const filterSelect = document.querySelector('.filter-nav.filter .filter-nav__item.is-active .filter-nav__link').getAttribute('data-select');
  request.send(`action=filter&select=${dataSelect}&filter=${filterSelect}${startDatePicker}${endDatePicker}&lang=${localData.lang}&id=${localData.id}`);
  request.onreadystatechange = function () {
    if (this.readyState === 4 && this.status === 200) {
      const response = JSON.parse(this.responseText);
      if (response.data.status === 200) {
        handleResponse(response.data, startDate, endDate);
      }
    }
  };
};

// Handle response //
const loadingScreen = document.querySelector('.loading');
const handleResponse = (data, startDate, endDate) => {
  const itemBox = document.querySelector('.sc-offer-list .offer-list__cards-list.card-list-1');
  const otherItemBox = document.querySelector('.sc-offer-list .offer-list__cards-list-wrapper.offer-list-2');
  const filterMessage = document.querySelector('.sc-offer-list .offer-list__no-result-message');
  if (data.offers.length === 0) {
    itemBox.innerHTML = '';
    otherItemBox.innerHTML = '';
    otherItemBox.style.display = 'none';
    filterMessage.classList.add('is-active');
  } else {
    filterMessage.classList.remove('is-active');
    let html = '';
    let extraClass = '';
    data.offers.forEach((offer) => {
      if (data.giftVouchers) {
        extraClass = 'gift-vouchers-card';
        html += '<article class="offer-card : offer-card--secondary : offer-card--longer-text">';
      } else {
        extraClass = 'offer-card';
        html += '<article class="offer-card : offer-card--secondary">';
      }
      html += `
  <a href="${offer.offer_card.button_href}" class="offer-card__link" role="link">
    <div class="offer-card__image">

      <div class="image-aspect : image-aspect--cover">
        <div class="image-aspect__bg" data-responsive="responsive-bg-image">
          <img class="responsive-bg-img : no-lazzy"
            src="${offer.offer_card.image_src}" alt="${offer.offer_card.image_alt}">
        </div>
      </div>
      <div class="offer-card__hover-content">
        <div class="offer-card__header">
          <div class="title : title--h3">
            <h3>${offer.offer_card.title}</h3>
          </div>
        </div>
        <div class="offer-card__content-inner">
          <div class="offer-card__info-text : ${extraClass}">
            <div class="editor-text ">${offer.offer_card.info_text}</div>
          </div>
          <div class="offer-card__additional-text : ${extraClass}">
            <div class="margin : margin--12"></div>
            <div class="editor-text ">
                <p>${offer.offer_card.additional_text}</p>
            </div>
          </div>
        </div>
        <div class="btn : btn--default">
          ${offer.offer_card.button_text}
        </div>
      </div>
    </div>
    <div class="offer-card__content">
      <div class="offer-card__header">
        <div class="title : title--h3">
          <h3>${offer.offer_card.title}</h3>
        </div>
      </div>
      <div class="offer-card__content-inner">
        <div class="offer-card__price-info">
        </div>
        <div class="offer-card__info-text : ${extraClass}">
          <div class="editor-text ">${offer.offer_card.info_text}</div>
        </div>
        <div class="offer-card__additional-text : ${extraClass}">
          <div class="margin : margin--12"></div>
          <div class="editor-text ">
            <p>${offer.offer_card.additional_text}</p>
          </div>
      </div>
      </div>
      <div class="btn : btn--default">${offer.offer_card.button_text}</div>
    </div>
  </a>
</article>`;
    });
    itemBox.innerHTML = html;
    let html2 = '';
    otherItemBox.innerHTML = html2;
    otherItemBox.style.display = 'none';
    if (data.others.length !== 0) {
      html2 = `<div class="title : title--h2">
                        <h2>${data.others_title}</h2>
                    </div>
                    <div class="margin : margin--32"></div>
                    <div class="offer-list__cards-list card-list-2">`;
      if (startDate && endDate) {
        data.others.forEach((other) => {
          html2 += `<article class="offer-card : offer-card--secondary">
                            <div class="offer-card__image">
                        <div class="image-aspect : image-aspect--cover">
                            <div class="image-aspect__bg" data-responsive="responsive-bg-image" style="background-image:
                            url(${other.offer_card.image_src});">
                                <img class="responsive-bg-img : no-lazzy" src="${other.offer_card.image_src}"
                                alt="${other.offer_card.image_alt}">
                            </div>
                        </div>
                                            <div class="offer-card__hover-content">
                                                            <div class="offer-card__header">
                        <div class="title : title--h3">
                                    <h3>${other.offer_card.title}</h3>
                            </div>
                                            </div>

                                        <div class="offer-card__content-inner">
                                                                    <div class="offer-card__info-text">
                                                    <div class="editor-text ">${other.offer_card.info_text}</div>
                                                </div>
                                                            </div>
                        <a class="btn : btn--default  " href="${other.offer_card.button_href}">
                                    <span class="btn__text">${other.offer_card.button_text}</span>
                            </a>
                                                    </div>
                                    </div>
                            <div class="offer-card__content">
                                            <div class="offer-card__header">

                        <div class="title : title--h3">
                                    <h3>${other.offer_card.title}</h3>
                            </div>
                                    </div>
                                <div class="offer-card__content-inner">
                                    <div class="offer-card__price-info">
                                                    </div>
                                                    <div class="offer-card__info-text">
                                            <div class="editor-text ">${other.offer_card.info_text}</div>
                                        </div>
                                            </div>
                        <a class="btn : btn--default  " href="${other.offer_card.button_href}">
                                    <span class="btn__text">${other.offer_card.button_text}</span>
                            </a>
                                    </div>
                        </article>`;
        });
        otherItemBox.innerHTML = html2;
        otherItemBox.style.display = 'block';
      }
    }
  }
  setTimeout(() => {
    loadingScreen.classList.remove('is-active');
  }, 300);
};

// Date picker //
const daterangepickerElem = document.querySelectorAll('.accordion__daterangepicker-inner');
daterangepickerElem.forEach((elem) => {
  // eslint-disable-next-line no-new
  const datepicker = new Litepicker({
    element: elem,
    numberOfColumns: 2,
    numberOfMonths: 2,
    singleMode: false,
    showTooltip: false,
    inlineMode: true,
    plugins: ['mobilefriendly'],
    mobilefriendly: {
      breakpoint: 767,
    },
    buttonText: {
      previousMonth: '<i class="icon : icon-chevron-left"></i>',
      nextMonth: '<i class="icon : icon-chevron-right"></i>',
    },
    lang: localData.locale,
    setup: (picker) => {
      picker.on('selected', (date1, date2) => {
        window.datepickerStart = date1;
        window.datepickerEnd = date2;
        getFilterOffersData();
      });
    },
  });

  attachEvent('.clear-daterangepicker', 'click', () => {
    window.datepickerStart = '';
    window.datepickerEnd = '';
    datepicker.clearSelection();
    datepicker.gotoDate(new Date());
    getFilterOffersData();
  });
});

// Filter links //
const selectedFilter = document.querySelectorAll('.filter-nav');
selectedFilter.forEach((filter) => {
  const filterLink = filter.querySelectorAll('li.filter-nav__item');

  filterLink.forEach((ev) => {
    ev.addEventListener('click', (e) => {
      loadingScreen.classList.add('is-active');
      e.preventDefault();
      filterLink.forEach((active) => {
        active.classList.remove('is-active');
      });
      ev.classList.add('is-active');

      getFilterOffersData();
    });
  });
});
